export default "__VITE_ASSET__C2PmL0DU__"